document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('a[href^="#section-"]');

  links.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      // Extract the number X from #section-X
      const match = link.getAttribute("href").match(/^#section-(\d+)$/);
      if (!match) return;

      const index = parseInt(match[1], 10);

      const container = document.querySelector("#MainContent");
      if (!container) return;

      const target = container.children[index - 1]; // because humans count from 1
      if (!target) return;

      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  });
});